<ng-container *ngIf="notification.data.returnUrl; else noReturnUrl">
    <a [routerLink]="notification.data.returnUrl" (click)="onTriggerAction()" class="return-link">
        <mat-icon *ngIf="notificationIcon"
                  class="notification-icon">
            {{ notificationIcon }}
        </mat-icon>

        <p class="notification-text">
            {{ notificationText }}
        </p>
    </a>

    <button mat-icon-button
            class="close-button"
            (click)="onDismissNotification()">
        <mat-icon>close</mat-icon>
    </button>
</ng-container>

<ng-template #noReturnUrl>
    <mat-icon *ngIf="notificationIcon"
              class="notification-icon">
        {{ notificationIcon }}
    </mat-icon>

    <p class="notification-text"
       (click)="onTriggerAction()">
        {{ notificationText }}
    </p>

    <button mat-icon-button
            class="close-button"
            (click)="onDismissNotification()">
        <mat-icon>close</mat-icon>
    </button>
</ng-template>
